import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import { RouteObject } from 'react-router-dom'

const TeamsLinkRoutes = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.teamsLink(),
    element: <TeamsLinkRoutes />,
  },
]

export default routes
